import { usePicture } from "@brickme/frontend-common/src/picture-edit/picture-edit-context.tsx";
import SliderInput from "~/components/slider-input.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import type { ConfirmSheetProps } from "~/components/sheet/confirm-sheet.tsx";
import ConfirmSheet from "~/components/sheet/confirm-sheet.tsx";

function BrightnessSheet(
	props: Pick<ConfirmSheetProps, "open" | "onDone" | "onCancel">,
) {
	const t = useTranslator();
	const { picture, patchPictureDebounced } = usePicture();

	return (
		<ConfirmSheet title={t("Adjust brightness")} {...props}>
			<form onSubmit={(e) => e.preventDefault()}>
				<SliderInput
					min={-100}
					max={100}
					step={1}
					value={Math.round(picture.brightness * 100)}
					onChange={(newValue) =>
						patchPictureDebounced({
							brightness: newValue / 100,
						})
					}
				/>
			</form>
		</ConfirmSheet>
	);
}

export default BrightnessSheet;
